module.exports = __webpack_public_path__ + "img/MED_PROCESSED_MEATS@300x.1998b83c.png";